import CenteredLayout from "@/layouts/CenteredLayout";
import { ErrorInfo } from "@/ui/blocks/cards/ErrorInfo";

export const ErrorFallbackPage = () => {
  const page = (
    <div className="w-2/3">
      <ErrorInfo />
    </div>
  );

  // use the centered layout component to get the page centered with background
  return <CenteredLayout page={page} />;
};
